const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:4001',
  },
  // URL where the chatbot widget JS is hosted (webpack-dev-server in dev, CDN in prod).
  // Used by the demo preview page to embed the widget in an iframe.
  widgetUrl: process.env.REACT_APP_WIDGET_URL || 'http://localhost:4003',
  // Base domain for multi-tenant resolution (e.g. "reruptionchat.com" in prod,
  // "staging.reruptionchat.com" in staging). Used to build tenant URLs in embed codes.
  baseDomain: process.env.REACT_APP_BASE_DOMAIN || 'localhost',
  endpoints: {
    chat: '/api/chat',
    chatAttachments: '/api/chat/attachments',
    auth: '/auth',
    settings: '/api/settings',
    leads: '/api/leads',
    userInfo: '/auth/userinfo',
    profile: '/auth/profile',
    profileAvatar: '/auth/profile/avatar',
    systemPrompt: '/api/settings/system-prompt',
    vectorStore: '/api/settings/vector-store',
    conversations: '/api/conversations',
    'vector-classifier-prompt': '/api/settings/vector-classifier-prompt',
    'vector-classifier-threshold': '/api/settings/vector-classifier-threshold',
    'product-classifier-prompt': '/api/settings/product-classifier-prompt',
    'product-classifier-threshold': '/api/settings/product-classifier-threshold',
    'system-prompt': '/api/settings/system-prompt',
    'vector-store-prompt': '/api/settings/vector-store-prompt',
    'vectorstore-id': '/api/settings/vectorstore-id',
    branding: '/api/branding',
    brandingUpload: '/api/branding/upload',
    brandingAsset: '/api/branding/asset',
    // Tenant management (platform admin)
    resolveTenant: '/api/resolve-tenant',
    tenants: '/api/tenants',
    modules: '/api/modules',
  }
};

export default config;
